

// import React, { useEffect, useState } from "react";
// import {
//   Box, Typography, Container, Grid, Card, Avatar, Stack, Chip, Button,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// const API_BASE = process.env.REACT_APP_API_URL;

// const getAvatarUrl = (profilePhoto) => {
//   if (!profilePhoto) return undefined;
//   if (profilePhoto.startsWith("http")) return profilePhoto;
//   return `${API_BASE.replace(/\/+$/, "")}/${profilePhoto.replace(/^\/+/, "")}`;
// };

// // Minimal avatar initial color based on name
// const avatarColor = (name = "") => {
//   const colors = ['#00C2B3', '#0088A3', '#007A70', '#004A5E'];
//   let h = 0;
//   for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
//   return colors[Math.abs(h) % colors.length];
// };

// function HomePage({ user, onlineUsers = [], setUser }) {
//   const navigate = useNavigate();
//   const [recentChats, setRecentChats] = useState([]);
//   const [dashboardUser, setDashboardUser] = useState(user);

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (!token || !user?._id) return;
//     axios.get(`${API_BASE}/api/users/${user._id}`, {
//       headers: { Authorization: `Bearer ${token}` }
//     }).then(res => {
//       setDashboardUser(res.data);
//       setUser && setUser(res.data);
//       localStorage.setItem('user', JSON.stringify(res.data));
//     }).catch(() => {});
//   }, [user?._id]);

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     axios.get(`${API_BASE}/api/messages`, {
//       headers: { Authorization: `Bearer ${token}` },
//     }).then(res => setRecentChats(res.data.reverse().slice(0, 6)))
//       .catch(() => {});
//   }, []);

//   const navItems = [
//     { label: 'Global Chat', path: '/group', icon: '💬' },
//     { label: 'Private Chat', path: '/private/select', icon: '🔒' },
//     { label: 'Groups', path: '/groups', icon: '👥' },
//     { label: 'Settings', path: '/settings', icon: '⚙️' },
//   ];

//   return (
//     <Box sx={{ minHeight: '100vh', bgcolor: '#090C0F' }}>
//       {/* Top accent line */}
//       <Box sx={{ height: 2, bgcolor: '#00C2B3', opacity: 0.6 }} />

//       <Container maxWidth="lg" sx={{ pt: 5, pb: 8, color: '#F0F4F8' }}>
//         {/* Header row */}
//         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 5, flexWrap: 'wrap', gap: 2 }}>
//           <Box>
//             <Typography sx={{
//               fontFamily: "'Outfit', sans-serif", fontWeight: 700,
//               fontSize: 28, color: '#F0F4F8', letterSpacing: '-0.02em',
//             }}>
//               Dashboard
//             </Typography>
//             <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#3A4A58' }}>
//               Welcome back,{' '}
//               <Box component="span" sx={{ color: '#00C2B3' }}>
//                 {dashboardUser?.username || 'User'}
//               </Box>
//             </Typography>
//           </Box>

//           {/* Profile chip */}
//           <Box sx={{
//             display: 'flex', alignItems: 'center', gap: 1.5,
//             bgcolor: '#0E1318', border: '1px solid #1A2228',
//             borderRadius: '12px', px: 2, py: 1,
//           }}>
//             <Avatar
//               src={getAvatarUrl(dashboardUser?.profilePhoto)}
//               sx={{ width: 32, height: 32, bgcolor: avatarColor(dashboardUser?.username), fontSize: 13, fontWeight: 700 }}
//             >
//               {!dashboardUser?.profilePhoto && dashboardUser?.username?.[0]?.toUpperCase()}
//             </Avatar>
//             <Box>
//               <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, fontWeight: 600, color: '#F0F4F8', lineHeight: 1.2 }}>
//                 {dashboardUser?.username}
//               </Typography>
//               <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 10, color: '#00C2B3' }}>
//                 ● online
//               </Typography>
//             </Box>
//           </Box>
//         </Box>

//         {/* Quick Nav */}
//         <Grid container spacing={1.5} sx={{ mb: 5 }}>
//           {navItems.map(item => (
//             <Grid item xs={6} sm={3} key={item.path}>
//               <Box
//                 onClick={() => navigate(item.path)}
//                 sx={{
//                   bgcolor: '#0E1318', border: '1px solid #1A2228',
//                   borderRadius: '12px', p: 2.5, cursor: 'pointer',
//                   display: 'flex', flexDirection: 'column', gap: 1,
//                   transition: 'all 0.15s',
//                   '&:hover': {
//                     borderColor: '#00C2B3', bgcolor: '#0E1820',
//                     transform: 'translateY(-1px)',
//                   },
//                 }}
//               >
//                 <Typography sx={{ fontSize: 22 }}>{item.icon}</Typography>
//                 <Typography sx={{
//                   fontFamily: "'Outfit', sans-serif", fontWeight: 600,
//                   fontSize: 14, color: '#F0F4F8',
//                 }}>
//                   {item.label}
//                 </Typography>
//               </Box>
//             </Grid>
//           ))}
//         </Grid>

//         {/* Two columns: online users + recent chats */}
//         <Grid container spacing={3}>
//           {/* Online users */}
//           <Grid item xs={12} md={4}>
//             <Box sx={{ bgcolor: '#0E1318', border: '1px solid #1A2228', borderRadius: '14px', p: 3 }}>
//               <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2.5 }}>
//                 <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600, fontSize: 15, color: '#F0F4F8' }}>
//                   Online now
//                 </Typography>
//                 <Box sx={{
//                   bgcolor: '#0A2520', border: '1px solid #0A3530',
//                   borderRadius: '6px', px: 1, py: 0.3,
//                 }}>
//                   <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 11, color: '#00C2B3' }}>
//                     {onlineUsers.length}
//                   </Typography>
//                 </Box>
//               </Box>

//               {onlineUsers.length === 0 ? (
//                 <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, color: '#2A3A48' }}>
//                   No other users online
//                 </Typography>
//               ) : (
//                 <Stack spacing={1.5}>
//                   {onlineUsers.map(usr => (
//                     <Box key={usr.id} sx={{
//                       display: 'flex', alignItems: 'center', gap: 1.5,
//                       p: 1.5, borderRadius: '10px', cursor: 'pointer',
//                       '&:hover': { bgcolor: '#111820' },
//                     }}
//                       onClick={() => navigate(`/private/${usr.id}`)}
//                     >
//                       <Box sx={{ position: 'relative' }}>
//                         <Avatar
//                           src={getAvatarUrl(usr.profilePhoto)}
//                           sx={{ width: 34, height: 34, bgcolor: avatarColor(usr.username), fontSize: 13, fontWeight: 700 }}
//                         >
//                           {!usr.profilePhoto && usr.username?.[0]?.toUpperCase()}
//                         </Avatar>
//                         <Box sx={{
//                           position: 'absolute', bottom: 0, right: 0,
//                           width: 9, height: 9, bgcolor: '#00C2B3',
//                           borderRadius: '50%', border: '1.5px solid #0E1318',
//                         }} />
//                       </Box>
//                       <Box>
//                         <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, fontWeight: 600, color: '#F0F4F8', lineHeight: 1.2 }}>
//                           {usr.username}
//                         </Typography>
//                         <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, color: '#3A4A58' }}>
//                           Click to message
//                         </Typography>
//                       </Box>
//                     </Box>
//                   ))}
//                 </Stack>
//               )}
//             </Box>
//           </Grid>

//           {/* Recent chats */}
//           <Grid item xs={12} md={8}>
//             <Box sx={{ bgcolor: '#0E1318', border: '1px solid #1A2228', borderRadius: '14px', p: 3 }}>
//               <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600, fontSize: 15, color: '#F0F4F8', mb: 2.5 }}>
//                 Recent messages
//               </Typography>

//               {recentChats.length === 0 ? (
//                 <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, color: '#2A3A48' }}>
//                   No recent messages yet.
//                 </Typography>
//               ) : (
//                 <Stack spacing={1.5}>
//                   {recentChats.map((chat, i) => (
//                     <Box
//                       key={chat._id || i}
//                       onClick={() => navigate(`/private/${chat.userId}`)}
//                       sx={{
//                         display: 'flex', alignItems: 'center', gap: 2,
//                         p: 1.5, borderRadius: '10px', cursor: 'pointer',
//                         border: '1px solid transparent',
//                         '&:hover': { bgcolor: '#111820', borderColor: '#1A2228' },
//                       }}
//                     >
//                       <Avatar
//                         sx={{ width: 38, height: 38, bgcolor: avatarColor(chat.username), fontSize: 14, fontWeight: 700 }}
//                       >
//                         {chat.username?.[0]?.toUpperCase()}
//                       </Avatar>
//                       <Box sx={{ flex: 1, minWidth: 0 }}>
//                         <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 14, fontWeight: 600, color: '#F0F4F8', lineHeight: 1.3 }}>
//                           {chat.username}
//                         </Typography>
//                         <Typography sx={{
//                           fontFamily: "'Outfit', sans-serif", fontSize: 12, color: '#3A4A58',
//                           overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
//                         }}>
//                           {chat.content || chat.message || 'Sent a file'}
//                         </Typography>
//                       </Box>
//                       <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 10, color: '#2A3A48', whiteSpace: 'nowrap' }}>
//                         {chat.createdAt ? new Date(chat.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
//                       </Typography>
//                     </Box>
//                   ))}
//                 </Stack>
//               )}
//             </Box>
//           </Grid>
//         </Grid>
//       </Container>
//     </Box>
//   );
// }

// export default HomePage;

import React, { useEffect, useState } from "react";
import {
  Box, Typography, Container, Grid, Avatar, Stack, Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL;

const getAvatarUrl = (photo) => {
  if (!photo) return undefined;
  if (photo.startsWith('http')) return photo;
  return `${API_BASE.replace(/\/+$/, '')}/${photo.replace(/^\/+/, '')}`;
};

const avatarColor = (name = "") => {
  const c = ['#00C2B3', '#0088A3', '#007A70', '#005A6E'];
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return c[Math.abs(h) % c.length];
};

function HomePage({ user, onlineUsers = [], setUser }) {
  const navigate = useNavigate();
  const [recentChats, setRecentChats] = useState([]);
  const [dashboardUser, setDashboardUser] = useState(user);

  // Fetch fresh user data (JWT doesn't include profilePhoto)
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token || !user?._id && !user?.id) return;
    const uid = user._id || user.id;
    axios.get(`${API_BASE}/api/users/${uid}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        setDashboardUser(res.data);
        setUser && setUser({ ...user, ...res.data });
        localStorage.setItem('user', JSON.stringify({ ...user, ...res.data }));
      })
      .catch(() => {});
  }, [user?._id || user?.id]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios.get(`${API_BASE}/api/messages`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setRecentChats(res.data.slice(-6).reverse()))
      .catch(() => {});
  }, []);

  // Filter self from online users
  const otherOnline = onlineUsers.filter(u => String(u.id) !== String(user?._id || user?.id));

  const navItems = [
    { label: 'Global Chat', path: '/group', icon: '🌐', desc: 'Chat with everyone' },
    { label: 'Private Chat', path: '/private/select', icon: '🔒', desc: 'Direct messages' },
    { label: 'Groups', path: '/groups', icon: '👥', desc: 'Group conversations' },
    { label: 'Profile', path: '/profile', icon: '👤', desc: 'Edit your profile' },
  ];

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#090C0F', pt: '56px' }}>
      <Container maxWidth="lg" sx={{ pt: { xs: 3, sm: 5 }, pb: 8, px: { xs: 2, sm: 3 } }}>

        {/* Welcome banner */}
        <Box sx={{
          bgcolor: '#0E1318', border: '1px solid #1A2228',
          borderLeft: '3px solid #00C2B3',
          borderRadius: '14px', p: { xs: 2.5, sm: 3.5 }, mb: 4,
          display: 'flex', alignItems: 'center', gap: 3, flexWrap: 'wrap',
        }}>
          <Box sx={{ position: 'relative' }}>
            <Avatar
              src={getAvatarUrl(dashboardUser?.profilePhoto)}
              sx={{
                width: { xs: 52, sm: 64 }, height: { xs: 52, sm: 64 },
                fontSize: { xs: 18, sm: 22 }, fontWeight: 700,
                bgcolor: '#00C2B3', color: '#090C0F',
              }}
            >
              {!dashboardUser?.profilePhoto && dashboardUser?.username?.[0]?.toUpperCase()}
            </Avatar>
            <Box sx={{
              position: 'absolute', bottom: 2, right: 2,
              width: 12, height: 12, bgcolor: '#00C2B3',
              borderRadius: '50%', border: '2px solid #0E1318',
            }} />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={{
              fontFamily: "'Outfit', sans-serif", fontWeight: 700,
              fontSize: { xs: 20, sm: 24 }, color: '#F0F4F8',
              letterSpacing: '-0.02em',
            }}>
              Welcome back, {dashboardUser?.username || 'User'}
            </Typography>
            <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, color: '#3A4A58' }}>
              {dashboardUser?.status || 'No status set'} · {otherOnline.length} others online
            </Typography>
          </Box>
          <Button
            onClick={() => navigate('/profile')}
            sx={{
              fontFamily: "'Outfit', sans-serif", textTransform: 'none', fontSize: 13,
              color: '#00C2B3', border: '1px solid #0A3530', borderRadius: '8px',
              px: 2, py: 0.8,
              '&:hover': { bgcolor: '#0E2020' },
            }}
          >
            Edit profile
          </Button>
        </Box>

        {/* Quick nav grid */}
        <Grid container spacing={1.5} sx={{ mb: 4 }}>
          {navItems.map(item => (
            <Grid item xs={6} sm={3} key={item.path}>
              <Box
                onClick={() => navigate(item.path)}
                sx={{
                  bgcolor: '#0E1318', border: '1px solid #1A2228',
                  borderRadius: '12px', p: { xs: 2, sm: 2.5 },
                  cursor: 'pointer', height: '100%',
                  display: 'flex', flexDirection: 'column', gap: 0.8,
                  transition: 'all 0.15s',
                  '&:hover': { borderColor: '#00C2B3', bgcolor: '#0E1820', transform: 'translateY(-1px)' },
                  '&:active': { transform: 'translateY(0)' },
                }}
              >
                <Typography sx={{ fontSize: { xs: 22, sm: 26 } }}>{item.icon}</Typography>
                <Typography sx={{
                  fontFamily: "'Outfit', sans-serif", fontWeight: 600,
                  fontSize: { xs: 13, sm: 14 }, color: '#F0F4F8',
                }}>
                  {item.label}
                </Typography>
                <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, color: '#3A4A58' }}>
                  {item.desc}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* Two-col layout */}
        <Grid container spacing={3}>
          {/* Online users */}
          <Grid item xs={12} md={4}>
            <Box sx={{ bgcolor: '#0E1318', border: '1px solid #1A2228', borderRadius: '14px', p: { xs: 2.5, sm: 3 }, height: '100%' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2.5 }}>
                <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600, fontSize: 14, color: '#F0F4F8' }}>
                  Online now
                </Typography>
                <Box sx={{
                  bgcolor: '#0A2520', border: '1px solid #0A3530', borderRadius: '6px', px: 1, py: 0.3,
                }}>
                  <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 11, color: '#00C2B3' }}>
                    {otherOnline.length}
                  </Typography>
                </Box>
              </Box>

              {otherOnline.length === 0 ? (
                <Box sx={{ textAlign: 'center', py: 4 }}>
                  <Typography sx={{ fontSize: 28, mb: 1 }}>👻</Typography>
                  <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, color: '#2A3A48' }}>
                    No one else online
                  </Typography>
                </Box>
              ) : (
                <Stack spacing={1}>
                  {otherOnline.map(usr => (
                    <Box
                      key={usr.id}
                      onClick={() => navigate(`/private/${usr.id}`)}
                      sx={{
                        display: 'flex', alignItems: 'center', gap: 1.5,
                        p: 1.2, borderRadius: '10px', cursor: 'pointer',
                        '&:hover': { bgcolor: '#111820' },
                      }}
                    >
                      <Box sx={{ position: 'relative', flexShrink: 0 }}>
                        <Avatar
                          src={getAvatarUrl(usr.profilePhoto)}
                          sx={{ width: 36, height: 36, fontSize: 13, fontWeight: 700, bgcolor: avatarColor(usr.username) }}
                        >
                          {!usr.profilePhoto && usr.username?.[0]?.toUpperCase()}
                        </Avatar>
                        <Box sx={{
                          position: 'absolute', bottom: 0, right: 0,
                          width: 9, height: 9, bgcolor: '#00C2B3',
                          borderRadius: '50%', border: '1.5px solid #0E1318',
                        }} />
                      </Box>
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, fontWeight: 600, color: '#F0F4F8', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {usr.username}
                        </Typography>
                        {usr.status && (
                          <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, color: '#3A4A58', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {usr.status}
                          </Typography>
                        )}
                      </Box>
                      <Box sx={{ color: '#2A3A48', flexShrink: 0 }}>
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                          <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </Box>
                    </Box>
                  ))}
                </Stack>
              )}
            </Box>
          </Grid>

          {/* Recent messages */}
          <Grid item xs={12} md={8}>
            <Box sx={{ bgcolor: '#0E1318', border: '1px solid #1A2228', borderRadius: '14px', p: { xs: 2.5, sm: 3 } }}>
              <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600, fontSize: 14, color: '#F0F4F8', mb: 2.5 }}>
                Recent global messages
              </Typography>

              {recentChats.length === 0 ? (
                <Box sx={{ textAlign: 'center', py: 4 }}>
                  <Typography sx={{ fontSize: 28, mb: 1 }}>💬</Typography>
                  <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, color: '#2A3A48' }}>
                    No messages yet
                  </Typography>
                </Box>
              ) : (
                <Stack spacing={1}>
                  {recentChats.map((chat, i) => (
                    <Box
                      key={chat._id || i}
                      onClick={() => navigate('/group')}
                      sx={{
                        display: 'flex', alignItems: 'center', gap: 2,
                        p: 1.5, borderRadius: '10px', cursor: 'pointer',
                        border: '1px solid transparent',
                        '&:hover': { bgcolor: '#111820', borderColor: '#1A2228' },
                      }}
                    >
                      <Avatar
                        src={getAvatarUrl(chat.profilePhoto)}
                        sx={{ width: 38, height: 38, fontSize: 13, fontWeight: 700, bgcolor: avatarColor(chat.username), flexShrink: 0 }}
                      >
                        {!chat.profilePhoto && chat.username?.[0]?.toUpperCase()}
                      </Avatar>
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, fontWeight: 600, color: '#F0F4F8', lineHeight: 1.3 }}>
                          {chat.username}
                        </Typography>
                        <Typography sx={{
                          fontFamily: "'Outfit', sans-serif", fontSize: 12, color: '#3A4A58',
                          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                        }}>
                          {chat.content || '📎 Sent a file'}
                        </Typography>
                      </Box>
                      <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 10, color: '#2A3A48', whiteSpace: 'nowrap', flexShrink: 0 }}>
                        {chat.createdAt ? new Date(chat.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
                      </Typography>
                    </Box>
                  ))}
                </Stack>
              )}

              <Button
                fullWidth
                onClick={() => navigate('/group')}
                sx={{
                  mt: 2, fontFamily: "'Outfit', sans-serif", textTransform: 'none', fontSize: 13,
                  color: '#00C2B3', border: '1px solid #0A3530', borderRadius: '8px',
                  py: 0.8, '&:hover': { bgcolor: '#0E2020' },
                }}
              >
                Open Global Chat →
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default HomePage;